import { useState, useRef, useEffect } from 'react';

// Axtarışlı combobox — mövcud siyahıdan seç VƏ YA yeni dəyər yaz (sərbəst mətn).
// Dəyər hər hərfdə YOX, fokusdan çıxanda (blur) / Enter / siyahıdan seçəndə commit olunur.
// Beləcə yazarkən valideyn yenidən qruplaşsa belə input remount olmur → kursor itmir.
//   value       — cari mətn (sərbəst)
//   onChange    — (text) => void   (yalnız commit anında çağırılır)
//   options     — string[] təkliflər
//   placeholder — input placeholder
//   inputClassName — input üçün əlavə class
export default function CreatableCombobox({ value = '', onChange, options = [], placeholder = '', inputClassName = '' }) {
    const [draft, setDraft]   = useState(value);
    const [open, setOpen]     = useState(false);
    const [active, setActive] = useState(-1);
    const [rect, setRect]     = useState(null);
    const wrapRef  = useRef(null);
    const inputRef = useRef(null);

    // Xarici value dəyişəndə (banket/məhsul yüklənəndə) draft-ı sinxronla
    useEffect(() => { setDraft(value); }, [value]);

    const q = String(draft || '').toLowerCase().trim();
    const filtered = (q ? options.filter(o => String(o).toLowerCase().includes(q)) : options).slice(0, 50);

    const measure = () => {
        const r = inputRef.current?.getBoundingClientRect();
        if (r) setRect({ top: r.bottom, left: r.left, width: r.width });
    };
    useEffect(() => {
        if (!open) return;
        measure();
        const on = () => measure();
        window.addEventListener('scroll', on, true);
        window.addEventListener('resize', on);
        return () => { window.removeEventListener('scroll', on, true); window.removeEventListener('resize', on); };
    }, [open]);

    const commit = (text) => { const v = text != null ? text : draft; if (v !== value) onChange(v); };
    const choose = (opt) => { setDraft(opt); setOpen(false); setActive(-1); commit(opt); };

    const onKeyDown = (e) => {
        if (e.key === 'ArrowDown')      { e.preventDefault(); setOpen(true); setActive(i => Math.min(i + 1, filtered.length - 1)); }
        else if (e.key === 'ArrowUp')   { e.preventDefault(); setActive(i => Math.max(i - 1, 0)); }
        else if (e.key === 'Enter')     { e.preventDefault(); if (open && active >= 0 && filtered[active]) choose(filtered[active]); else { setOpen(false); commit(); } }
        else if (e.key === 'Escape')    { setDraft(value); setOpen(false); }
    };

    return (
        <div ref={wrapRef} className="relative">
            <input
                ref={inputRef}
                type="text"
                value={draft}
                onChange={(e) => { setDraft(e.target.value); setOpen(true); setActive(-1); }}
                onFocus={() => setOpen(true)}
                onBlur={() => { setOpen(false); commit(); }}   // commit yalnız burada → yazarkən remount olmur
                onKeyDown={onKeyDown}
                placeholder={placeholder}
                className={inputClassName}
            />
            {open && filtered.length > 0 && rect && (
                <div
                    style={{ position: 'fixed', top: rect.top + 2, left: rect.left, width: Math.max(rect.width, 170), zIndex: 60 }}
                    className="max-h-52 overflow-y-auto rounded-lg border border-gray-200 bg-white shadow-xl"
                >
                    {filtered.map((o, i) => (
                        <button
                            key={o}
                            type="button"
                            onMouseDown={(e) => e.preventDefault()}   // input blur olmasın (seçim itməsin)
                            onMouseEnter={() => setActive(i)}
                            onClick={() => choose(o)}
                            className={`block w-full truncate px-3 py-1.5 text-left text-xs ${
                                i === active
                                    ? 'bg-primary-100 text-primary-800'
                                    : String(o) === String(draft)
                                        ? 'bg-primary-50 font-semibold text-primary-700'
                                        : 'text-gray-700 hover:bg-gray-50'
                            }`}
                        >
                            {o}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
